import dialogSchema from './dialog-schema.graphql';


export { dialogSchema };
